export enum SeatStatusEnum {
    AVAILABLE = "A",
    PROCESSING = "P",
    SELECTED = "S",
    UNAVAILABLE = "U",
}

export type PlanSeat = {
    id: number,
    x: number,
    y: number,
    size: number,
    state: SeatStatusEnum
}